export default "__VITE_ASSET__6aa0ccb4__"